module.exports = Coveo;